import createHistory from 'history/createBrowserHistory';
const basename = '';//process.env.REACT_APP_NODE_ENV === 'staging' ? '/clients/spaceapegames/sag-proto/' : '';
const history = createHistory({basename});

export default history;


// WEBPACK FOOTER //
// ./src/modules/router/history.js